// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1W-dw","title":"AfterFrontImage_title__12fmg"};